var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRepliedIconSeq = function SvgRepliedIconSeq(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "preview_FILL0_wght400_GRAD-25_opsz20",
    d: "M153.82-799a.789.789,0,0,1-.579-.241.789.789,0,0,1-.241-.579v-6.361a.789.789,0,0,1,.241-.579.789.789,0,0,1,.579-.241h6.361a.789.789,0,0,1,.579.241.789.789,0,0,1,.241.579v6.361a.789.789,0,0,1-.241.579.789.789,0,0,1-.579.241Zm0-.82h6.361v-5.48H153.82ZM157-800.81a2.725,2.725,0,0,1-1.6-.5,2.865,2.865,0,0,1-1.024-1.254,2.862,2.862,0,0,1,1.025-1.254,2.731,2.731,0,0,1,1.606-.5,2.725,2.725,0,0,1,1.6.5,2.865,2.865,0,0,1,1.024,1.254,2.862,2.862,0,0,1-1.025,1.254A2.732,2.732,0,0,1,157-800.81Zm0-.563a2.262,2.262,0,0,0,1.181-.315,2.19,2.19,0,0,0,.824-.872,2.186,2.186,0,0,0-.825-.872,2.269,2.269,0,0,0-1.182-.314,2.262,2.262,0,0,0-1.181.315,2.19,2.19,0,0,0-.824.872,2.186,2.186,0,0,0,.825.872A2.269,2.269,0,0,0,157-801.373ZM157-802.56Zm0,.691a.667.667,0,0,0,.49-.2.666.666,0,0,0,.2-.489.667.667,0,0,0-.2-.49.665.665,0,0,0-.489-.2.667.667,0,0,0-.49.2.666.666,0,0,0-.2.489.667.667,0,0,0,.2.49A.665.665,0,0,0,157-801.868Z",
    transform: "translate(-153 807)",
    fill: "#28ad56"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRepliedIconSeq, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/repliedIconSeq.54d122d9.svg";
export { ForwardRef as ReactComponent };